import Modal from "shared/components/feedback/modals/MasterModal";
import React from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";

const GenericModal = ({
    parent,
    show,
    content,
    onHide,
    onClose,
    backdrop,
    keyboard,
    title,
    width,
    closable,
}) => {

    const handleClose = () => {
        if (closable === false) {
            return; // Prevent closing if not closable
        }
        if (onClose) {
            onClose();
        } else {
            ReactDOM.render(null, document.getElementById(parent));
        }
        document.body.style.removeProperty('style');
    };

    return (
        <Modal
            stickyAction={false}
            onRequestClose={closable ? handleClose : undefined}
            title={title}
            showFooter={false}
            width={width}
        >
            {content}
        </Modal>
    );
};

GenericModal.defaultProps = {
    show: true,
    content: null,
    onHide: null,
    onClose: null,
    backdrop: globalThis.config.modal.backdrop,
    keyboard: globalThis.config.modal.keyboard,
    title: "",
    closable: true,
};

GenericModal.propTypes = {
    parent: PropTypes.string,
    show: PropTypes.bool,
    content: PropTypes.node,
    onHide: PropTypes.func,
    onClose: PropTypes.func,
    backdrop: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    keyboard: PropTypes.bool,
    title: PropTypes.string,
    width: PropTypes.string,
    closable: PropTypes.bool,
};

export default GenericModal;
